import arrowDown from '../images/arrow-down.svg';
import arrowLeftGrey from '../images/arrow-left-grey.svg';
import arrowRight from '../images/arrow-right.svg';
import arrowRightGrey from '../images/arrow-right-grey.svg';
import arrowRightWhite from '../images/arrow-right-white.svg';
import checkIcon from '../images/check-icon.svg';
import decorBar from '../images/decor-bar.svg';
import errorIcon from '../images/error_icon_2x.png'
import preloader from '../images/preloader.svg';
import researcherImg from '../images/researcher-img.svg';
import searchIcon from '../images/search-icon.svg';
import suitcaseIcon from '../images/suitcase-icon.svg';
import technologyHeader from '../images/technology-header-bg.svg';
import researcherHeader from '../images/researcher-header.svg';